import { render, staticRenderFns } from "./DefaultDetails.vue?vue&type=template&id=79330272&"
import script from "./DefaultDetails.vue?vue&type=script&lang=ts&"
export * from "./DefaultDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports